export const companyFields = {
  name: "企業名",
  business_contents: "事業内容",
  characteristics: "企業理念・特徴",
  representative: "代表者",
  address: "本社所在地",
  home_page: "ホームページURL",
  foundation: "設立",
  capital: "資本金"
}